<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
            </ul>
        </div>    
        <div class="mainindex">
            <div class="welinfo">
                <span><img src="../assets/images/sun.png" alt="天气" /></span>
                <b>{{account}}&nbsp;&nbsp;{{time}}，欢迎使用云办公开放平台</b>
                <!-- <a href="/personinfo">帐号设置</a> -->
            </div>
    
            <div class="welinfo">
                <span><img src="../assets/images/time.png" alt="时间" /></span>
                <i>您上次登录的时间：{{lastLoginTime}}</i>
                <!-- <template v-if="userCouponList != null && userCouponList.length>0"><i class="f18">您有<a style="font-size: 24px;color: #c70931;cursor: pointer;" href="#" @click="goUserCoupon">{{userCouponList.length}}</a> 张充值抵用券即将到期！请尽快<a style="font-size: 36px; color: #EE680E" href="#" @click="goCharge">去充值</a>！</i> </template> -->
                                
            </div> 
              
            
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
var scrollingBox;
var scrollingInterval;
var reachedBottom = false;
var bottom;
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            lastLoginTime:'',
            tiXingList:[],
            account:'',
            time:'',
            userCouponList:[]
        }
    },
    mounted(){
        this.getData();
        let hours = new Date().getHours();
        if( hours >= 0 && hours < 6 ){
            this.time = '凌晨好';
        }else if( hours>= 6 && hours < 9 ){
            this.time = '早上好';
        }else if( hours >= 9 && hours < 12 ){
            this.time = '上午好';
        }else if( hours == 12 ){
            this.time = '中午好';
        }else if ( hours > 12 && hours < 18 ){
            this.time = '下午好';
        }else if( hours >= 18 && hours <22 ){
            this.time = '晚上好';
        }else{
            this.time = '深夜好';
        }
        
    },
    created(){
        this.addEventSimple(window, 'load', this.initScrolling);
    },
    methods:{
        getData(){
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/main/desktopinfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(JSON.stringify(res.data));
                if('0000000' == res.data.code)
                {
                    that.lastLoginTime = res.data.lastLoginTime;
                    that.tiXingList = res.data.tiXingList;
                    that.account = res.data.account;
                    that.userCouponList = res.data.userCouponList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addEventSimple(obj, evt, fn) {
            if (obj.addEventListener) {
                obj.addEventListener(evt, fn, false);
            } else if (obj.attachEvent) {
                obj.attachEvent('on' + evt, fn);
            }
        },
        initScrolling() {
            scrollingBox = document.getElementById('xst');
            scrollingBox.style.overflow = "hidden";
            scrollingInterval = setInterval(this.scrolling, 100);
            scrollingBox.onmouseover = this.over;
            scrollingBox.onmouseout = this.out;
        },
        scrolling() {
            var origin = scrollingBox.scrollTop++;
            if (origin == scrollingBox.scrollTop) {
                if (!reachedBottom) {
                    scrollingBox.innerHTML += scrollingBox.innerHTML;
                    reachedBottom = true;
                    bottom = origin;
                } else {
                    scrollingBox.scrollTop = bottom;
                }
            }
        },
        over() {
            clearInterval(scrollingInterval);
        },
        out() {
            scrollingInterval = setInterval(this.scrolling, 100);
        },
        goCharge(){
            location.href = "chargeaccount";
        },
        goUserCoupon(){
            location.href = "usercoupon";
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/desktop.vue